import React from 'react';
import clsx from 'clsx';
function HeaderBrand(_ref) {
  let {
    onClick,
    className,
    children: brand,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(brand.type, Object.assign({
    className: clsx(className, 'header-brand')
  }, brand.props, rest, onClick && {
    onClick: e => {
      onClick(e, {
        ...brand.props,
        linkContext: 'HeaderHome'
      });
      return true;
    }
  }));
}
export default HeaderBrand;